var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 59,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_84_110",
    transform: "translate(0 0.00847458) scale(0.0104167 0.0102401)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_84_110",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACSElEQVR4nO3bMXLTQBiG4W8dinQMV7CHE6SAjjLpE3MOp8IlNExS4ZzDTg0ThhlKcgbAd3CXNFoKRgOFZ/BKq/2E9D61xlr/byRLtiIBAAAAAABgLELpHU4vVm9CjFe5Xu/n7WWn72F2/iGmbJ+6nknactrbbhbXMYRl6f32VfEAEhH+ZgkgEaFmCyARQTIHkIhgDyCNO0IvAkjSUdRXKTy411FaLwLM5jcnleJHKR6711KaPcBsfnOiqvos6Zl7LQ7WAGMfvmQMwPB/swR4fr56oar6osOG/9j1epyKB/jzgaunB2y+myi8GvIl6pOSO0s87ewmCqffbxf3ku6nFyvl/Ba1L4odAS2GL2m4N2tFArQdfm2IEToPkGv4taFF6DRA7uHXhhShswCJl5oHD7+23SyuQ9C75ivsh04CNLjUTBp+7cfm8m366vole4CuTjtDlTUAw0+XLQDDbyZLAIbfXOsADL+dVgEYfnuNAzD8PBoFYPj5JAdg+HklB4hV9V4MP5v0U9Dk8bUUvv1jK4Z/oORfxLbr5W46vzoL1fEnKb7cs4l1+F0/z59bow/h7Xq5i5OHsz1HAn/5iRpfhu6JwPAbaHUjVkeI0h3Db6b1UxHb9XIn6TTDWkbJ/mzo2BHAjABmBDAjgBkBzAhgRgAzApgRwIwAZkX/Q2af/+37+9w4AswIYEYAMwKYEcCMAGYEMEu+Dxj7dXtuHAFmBDAjgBkBzAhgRgAzApgRwIwAZgQwI4AZAcwIYEYAMwIAAAAAAAAAhfwCMt8hsEi/incAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.84834ce5bda48253ef4a50944e90a5b4.svg";
export { ForwardRef as ReactComponent };